"use strict";

var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Text = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n"])));
exports.default = function (props) {
  return _react2.default.createElement(Text, props);
};